<template>
  <icon-base class="sort-arrow" red>
    <icon-arrow-min-filled :up="sortOrder === 'asc'" />
  </icon-base>
</template>

<script>
import { IconArrowMinFilled } from 'Icons';

export default {
  components: {
    IconArrowMinFilled,
  },
  props: {
    sortOrder: String,
  },
};
</script>

<style lang="scss" scoped>
.sort-arrow {
  margin-left: 5px;
  position: relative;
  top: -1px;
}
</style>




// WEBPACK FOOTER //
// src/components/uikit/SortingArrow.vue